import { concourseId } from '@/constants/activity-constants'
import userSessionStorage from '@/context/userSessionStorage'
import SignService from '@/services/sign-service'
import { useEffect, useState } from 'react'

export async function requestIfUserHasSign(): Promise<boolean> {
  const token = userSessionStorage.getToken()
  if (!token) {
    return false
  }
  const config = {
    headers: {
      Authorization: token.idToken,
    },
  }
  return SignService.getUserSign(concourseId, config).then(response => {
    if (response.status === 200) {
      return response.data && response.data.data.state === 1
    }

    return false
  })
}

export default function useUserSigned() {
  const [signed, setSigned] = useState(false)
  const revalidate = () => {
    requestIfUserHasSign().then((_signed: boolean) => {
      setSigned(_signed ? true : false)
    })
  }
  useEffect(() => {
    revalidate()
  }, [])
  return [signed, revalidate]
}
